// extracted by extract-css-chunks-webpack-plugin
module.exports = {"detail-size-container":"FmHe7","detailsWidth":"wjnkF"};